import { Button, ButtonProps } from "primereact/button";
import React from "react";
import styled from "styled-components";
import { concatClassnames } from "../../utils/util";
import { device } from "../../constants/mediaQueries";

export interface CvpButtonProps extends ButtonProps {
  label?: string;
}

export const CvpButton = (props: CvpButtonProps) => {
  const { label, className, ...otherProps } = props;
  return (
    <StyledCvpButton
      iconPos="right"
      label={label}
      className={concatClassnames(["cvp-button", className])}
      {...otherProps}
    />
  );
};

const StyledCvpButton = styled(Button)`
  &.cvp-button {
    padding: 0.6rem 1rem;
    display: flex;
    align-items: center;

    .p-button-label {
      font-weight: 600;
      font-size: 0.85em;
    }

    .p-button-icon {
      font-size: 0.85em;
    }
    &.p-button:focus {
      box-shadow: 0 0 0 0.1rem var(--primary-200);
    }

    &.active-btn {
      background: var(--primary-500);
      color: white;
      border: 1px solid var(--primary-500);
    }
  }
`;
